import React from "react";
// import { ContentWithCardLoading } from "../../components/loading";
import { Route, Switch } from "react-router-dom";
import AdminCampaignList from "./container/account-camapign/containers/account-campaign-list";
import AccountCampaignPricingRoutes from "./container/account-campaign-pricing";
import AccountList from "./container/account-list";
import AccountUser from "./container/account-user";
import AccountWallet from "./container/account-wallet";
import AccountLoginSessions from "./container/account-login-sessions";
import AccountSettings from "./container/account-settings";
import RCSBotConfiguration from "./container/account-rcs-bot-config";
import CampaignSummary from "./container/campaign-summary";

export default function AccountsRoutes({ match }) {
  return (
    <Switch>
      <Route exact path={`${match.url}/`} component={AccountList} />
      <Route exact path={`${match.url}/:accountId/campaigns`} component={AdminCampaignList} />
      <Route exact path={`${match.url}/:accountId/team-members`} component={AccountUser} />
      <Route exact path={`${match.url}/:accountId/campaign-pricing`} component={AccountCampaignPricingRoutes} />
      <Route exact path={`${match.url}/:accountId/wallet`} component={AccountWallet} />
      <Route exact path={`${match.url}/:accountId/sessions`} component={AccountLoginSessions} />
      <Route exact path={`${match.url}/:accountId/settings`} component={AccountSettings} />
      <Route exact path={`${match.url}/:accountId/rcs-bot-config`} component={RCSBotConfiguration} />
      <Route exact path={`${match.url}/:accountId/summary`} component={CampaignSummary} />
    </Switch>
  );
}
